import { render, staticRenderFns } from "./ArtistDashboard.vue?vue&type=template&id=89e176bc"
import script from "./ArtistDashboard.vue?vue&type=script&lang=js"
export * from "./ArtistDashboard.vue?vue&type=script&lang=js"
import style0 from "./ArtistDashboard.vue?vue&type=style&index=0&id=89e176bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports